import Wrapper from "../../../layout/Wrapper";
import ActionLogComponent from "../../../screens/settings/action-log";
import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
    title: "User Action Log",
    description: "Audit user actions and API activity",
};

export default function ActionLogPage() {
    return (
        <Wrapper>
            <MetaComponent meta={metadata} />
            <ActionLogComponent />
        </Wrapper>
    );
}
